import styled from 'styled-components';
import { getStyles } from '@kubit/web-ui-components';
const FiguresMainWrapperStyled = styled.section `
  ${({ styles }) => {
    return getStyles(styles?.container);
}}
`;
FiguresMainWrapperStyled.displayName = 'FiguresMainWrapperStyled';
const FigureWrapperStyled = styled.section `
  ${({ styles }) => {
    return getStyles(styles?.figureContainer);
}}
`;
FigureWrapperStyled.displayName = 'FigureWrapperStyled';
export { FiguresMainWrapperStyled, FigureWrapperStyled };
//# sourceMappingURL=figures.component.styled.js.map